export const NAVIGATOR = {
    ADMIN: [
        {
            label: 'Administración',
            keyLg: "admistration",
            icon: 'fas fa-book',
            iconImg: 'ico_administracion.svg',
            children: true,
            show: true,
            order: 2,
            childrenContent: [
                {
                    label: 'Avisos de privacidad',
                    keyLg: "privacyNotice",
                    icon: 'fa-solid fa-shield-halved',
                    iconImg: 'ico_AvisoDePrivacidad.svg',
                    link: '/management/list-notice-of-privacy',
                    children: false,
                    show: true,
                    order: 22,
                    childrenContent: []
                },
                {
                    label: 'Contratos',
                    keyLg: "contract",
                    icon: 'fa-solid fa-file-contract',
                    iconImg: 'ico_contratos.svg',
                    link: '/management/list-contract',
                    children: false,
                    show: true,
                    order: 23,
                    childrenContent: []
                },
                {
                    label: 'Productos',
                    keyLg: "products",
                    icon: 'fas fa-book',
                    iconImg: 'ico_productos.svg',
                    link: '/management/list-products',
                    children: false,
                    show: true,
                    order: 24,
                    childrenContent: []
                },
                {
                    label: 'Sucursales',
                    keyLg: "branches",
                    icon: 'fa-solid fa-map-location-dot',
                    iconImg: 'ico_sucursales.svg',
                    link: '/management/list-branches',
                    children: false,
                    show: true,
                    order: 25,
                    childrenContent: []
                },
                {
                    label: 'Otros documentos',
                    keyLg: "otherDocuments",
                    icon: 'fa-solid fa-map-location-dot',
                    iconImg: 'ico_documentos.svg',
                    link: '/management/list-other-documents',
                    children: false,
                    show: false,
                    order: 26,
                    childrenContent: []
                },
                {
                    label: 'Usuarios',
                    keyLg: "users",
                    icon: 'fas fa-user',
                    iconImg: 'ico_usuarios.svg',
                    link: '/management/list-user',
                    children: false,
                    show: true,
                    order: 27,
                    childrenContent: []
                },
                {
                    label: 'Transacciones',
                    keyLg: "transactions",
                    icon: 'fas fa-user',
                    iconImg: 'arrow_swap.svg',
                    link: '/management/list-transactions',
                    children: false,
                    show: true,
                    order: 28,
                    childrenContent: []
                }
            ]
        },
        {
            label: 'Empadronar',
            keyLg: "enroll",
            icon: 'fa-solid fa-file-waveform',
            iconImg: 'ico_empadronar.svg',
            link: '/management/enrollment/enrollment',
            children: false,
            show: true,
            order: 5,
            childrenContent: []
        },
        {
            label: 'Verificación',
            keyLg: "verify",
            icon: 'fa-regular fa-circle-check',
            iconImg: 'ico_verificacion.svg',
            link: '/management/customer-verify/customer-verify-list',
            children: false,
            show: true,
            order: 6,
            childrenContent: []
        },
        {
            label: 'Pase de lista',
            keyLg: "rollCall",
            icon: 'fa-regular fa-circle-check',
            iconImg: 'ico_controlAsistencia.svg',//ico_paseLista.svg
            children: true,
            show: true,
            order: 7,
            childrenContent: [
                {
                    label: 'Dashboard CAE',
                    keyLg: "dashboardcae",
                    icon: 'fa-regular fa-circle-check',
                    iconImg: 'Ico_DashboardCAE.svg',
                    link: '/management/dashboard-cae',
                    children: false,
                    show: true,
                    order: 76,
                    childrenContent: []
                },
                {
                    label: 'Sucursal CAE',
                    keyLg: "branchcae",
                    icon: 'fa-solid fa-building',
                    iconImg: 'Ico_DashboardCAE.svg',
                    link: '/management/branches-cae',
                    children: false,
                    show: true,
                    order: 77,
                    childrenContent: []
                },
                {
                    label: 'Pase de lista',
                    keyLg: "control",
                    icon: 'fa-regular fa-circle-check',
                    iconImg: 'ico_controlAsistencia.svg',
                    link: '/list-roll-call',
                    children: false,
                    show: true,
                    order: 71,
                    childrenContent: []
                },
                {
                    label: 'Grupos',
                    keyLg: "groups",
                    icon: 'fa-solid fa-people-group',
                    iconImg: 'ico_grupo.svg',
                    link: '/management/list-groups',
                    children: false,
                    show: true,
                    order: 72,
                    childrenContent: []
                },
                {
                    label: 'Horarios',
                    keyLg: "schedule",
                    icon: 'fa-solid fa-file-contract',
                    iconImg: 'ico_horarios_submenu.svg',
                    link: '/schedule/list',
                    children: false,
                    show: true,
                    order: 73,
                    childrenContent: []
                },
                {
                    label: 'Usuarios',
                    keyLg: "caeuserlist",
                    icon: 'fa-solid fa-file-contract',
                    iconImg: 'ico_userCAE.svg',
                    link: '/cae-user-list',
                    children: false,
                    show: true,
                    order: 74,
                    childrenContent: []
                },
                {
                    label: 'Bitácora Usuarios',
                    keyLg: "recordcaeuserlist",
                    icon: 'fa-solid fa-file-contract',
                    iconImg: 'ico_bitacora.svg',
                    link: '/record-caeuser-list',
                    children: false,
                    show: true,
                    order: 75,
                    childrenContent: []
                }
            ]
        }
    ],
    SUPERADMIN: [
        {
            label: 'Compañías',
            keyLg: "companies",
            icon: 'fa-solid fa-building-user',
            iconImg: 'ico_companias.svg',
            link: '/list-company',
            children: false,
            show: true,
            order: 3,
            childrenContent: []
        }
    ],
    USER: [
        {
            label: 'Empadronar',
            keyLg: "enroll",
            icon: 'fa-solid fa-file-waveform',
            iconImg: 'ico_empadronar.svg',
            link: '/management/enrollment/enrollment',
            children: false,
            show: true,
            order: 5,
            childrenContent: []
        },
        {
            label: 'Verificación',
            keyLg: "verify",
            icon: 'fa-regular fa-circle-check',
            iconImg: 'ico_verificacion.svg',
            link: '/management/customer-verify/customer-verify-list',
            children: false,
            show: true,
            order: 6,
            childrenContent: []
        }
    ],
    RRHH: [
        {
            label: 'Dashboard',
            keyLg: "dashboard",
            icon: 'fas fa-chart-area',
            iconImg: 'ico_dashboard.svg',
            link: '/list-documents',
            children: false,
            show: true,
            order: 1,
            childrenContent: []
        },
        {
            label: 'Pase de lista',
            keyLg: "rollCall",
            icon: 'fa-regular fa-circle-check',
            iconImg: 'ico_controlAsistencia.svg',//ico_paseLista.svg
            //link: '/list-roll-call',
            children: true,
            show: true,
            order: 7,
            childrenContent: [
                {
                    label: 'Pase de lista',
                    keyLg: "control",
                    icon: 'fa-regular fa-circle-check',
                    iconImg: 'ico_controlAsistencia.svg',
                    link: '/list-roll-call',
                    children: false,
                    show: true,
                    order: 71,
                    childrenContent: []
                },
                {
                    label: 'Grupos',
                    keyLg: "groups",
                    icon: 'fa-solid fa-people-group',
                    iconImg: 'ico_grupo.svg',
                    link: '/management/list-groups',
                    children: false,
                    show: true,
                    order: 72,
                    childrenContent: []
                },
                {
                    label: 'Horarios',
                    keyLg: "schedule",
                    icon: 'fa-solid fa-file-contract',
                    iconImg: 'ico_horarios_submenu.svg',
                    link: '/schedule/list',
                    children: false,
                    show: true,
                    order: 73,
                    childrenContent: []
                },
                {
                    label: 'Usuarios',
                    keyLg: "caeuserlist",
                    icon: 'fa-solid fa-file-contract',
                    iconImg: 'ico_userCAE.svg',
                    link: '/cae-user-list',
                    children: false,
                    show: true,
                    order: 74,
                    childrenContent: []
                }
            ]
        }
    ],
    EXECUTIVE: [
        {
            label: 'Dashboard',
            keyLg: "dashboard",
            icon: 'fas fa-chart-area',
            iconImg: 'ico_dashboard.svg',
            link: '/list-documents',
            children: false,
            show: true,
            order: 1,
            childrenContent: []
        },
        {
            label: 'Pase de lista',
            keyLg: "rollCall",
            icon: 'fa-regular fa-circle-check',
            iconImg: 'ico_controlAsistencia.svg',//ico_paseLista.svg
            //link: '/list-roll-call',
            children: true,
            show: true,
            order: 7,
            childrenContent: [
                {
                    label: 'Pase de lista',
                    keyLg: "control",
                    icon: 'fa-regular fa-circle-check',
                    iconImg: 'ico_controlAsistencia.svg',
                    link: '/list-roll-call',
                    children: false,
                    show: true,
                    order: 71,
                    childrenContent: []
                },
                {
                    label: 'Horarios',
                    keyLg: "schedule",
                    icon: 'fa-solid fa-file-contract',
                    iconImg: 'ico_horarios_submenu.svg',
                    link: '/schedule/list',
                    children: false,
                    show: true,
                    order: 72,
                    childrenContent: []
                }
            ]
        }
    ],
    SHARED: [
        // {
        //     label: 'Dashboard',
        //     keyLg: "dashboard",
        //     icon: 'fas fa-chart-area',
        //     iconImg: 'ico_dashboard.svg',
        //     link: '/list-documents',
        //     children: false,
        //     show: true,
        //     order: 1,
        //     childrenContent: []
        // },
        // {
        //     label: 'Bitácora',
        //     keyLg: "binnacle",
        //     icon: 'fas fa-clock',
        //     iconImg: 'ico_bitacora.svg',
        //     link: '/list-history',
        //     children: false,
        //     show: true,
        //     order: 4,
        //     childrenContent: []
        // },
        {
            label: 'Usuarios',
            keyLg: "caeuserlist",
            icon: 'fa-solid fa-file-contract',
            iconImg: 'ico_userCAE.svg',
            link: '/cae-user-list',
            children: false,
            show: true,
            order: 1,
            childrenContent: []
        }
    ]
}


export interface Menu {
    label: string,
    keyLg: string,
    icon: string,
    iconImg?: string,
    link?: string,
    children: boolean,
    show: boolean,
    order: number,
    childrenContent: Array<any>
}